<div class="lm-image">
  <div *ngFor="let col of imageColumn; trackBy: trackByIndex;">
    <lm-element
        *ngIf="col"
        [layoutObject]="col"
        [layoutInfo]="layoutInfo"
        [lmColumnLayoutInfo]="lmColumnLayoutInfo"
        [specFields]="specFields"
        [placeHolder]="placeHolder"
        [model]="model"
        (fieldEvent)="onFieldEvent($event)"
    ></lm-element>
  </div>
</div>
<div class="lm-elements">
  <div class="row" [ngStyle]="{'display': !lmColumnLayoutInfo?.distributed ? 'flex' : null}">
    <div *ngFor="let col of columns; trackBy: trackByIndex;" [ngClass]="{'lm-column': true, 'lm-column-distributed': lmColumnLayoutInfo?.distributed}">
      <lm-element
          *ngIf="col"
          [layoutObject]="col"
          [layoutInfo]="layoutInfo"
          [lmColumnLayoutInfo]="lmColumnLayoutInfo"
          [specFields]="specFields"
          [placeHolder]="placeHolder"
          [model]="model"
          (fieldEvent)="onFieldEvent($event)"
      ></lm-element>
    </div>
  </div>
</div>
